import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/api';

import { Certificate } from './types';

@Injectable({
  providedIn: 'root'
})
export class CertificatesService {
  private readonly apiService = inject(ApiService);

  getCertificate(certificateId: number): Observable<Certificate> {
    return this.apiService.get<Certificate>(`/Certificates/${certificateId}`);
  }
}
